import { Search } from "react-feather";
import styled from "styled-components";

export const WrapIcon = styled.div`
  border-radius: 20px;
  border: 1px solid #fff;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 15px;
  padding-right: 15px;
  color: #fff;
  margin-top: -8px;
`;

export const WrapSearchMob = styled.a`
  width: 100%;
  height: auto;
  display: flex;
  position: absolute;
  top: 220px;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  @media (min-width: 1024px) {
    display: none;
  }
`;

export const WrapIconMob = styled.div`
  border-radius: 20px;
  border: 1px solid #fff;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 15px;
  padding-right: 15px;
  color: #fff;
`;

export const IconSearchStyled = styled(Search)`
  color: #fff;
  margin-right: 5px;
`;
export const MenuRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: 20px;
  width: 100%;
  background: #000;
`;
